import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'cargoes-customs-clearance',
  templateUrl: './customs-clearance.component.html',
})
export class CustomsClearanceComponent implements OnInit {

  @Input() defaultFormData: any;
  @Output() submitedFormData = new EventEmitter<any>();
  cusomsClearanceGroup!: FormGroup;
  inspectionStatusList:any[] = [];
  rejectionReasonList:any[] = [];
  load = false;
  showrejectionReason = false;
  formData = { "variables": {
    "clearanceStatus":{},
    "rejectionReason":{},
    "comments":{}
  } };

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    if(typeof this.defaultFormData === 'object' ){
      this.onLoad(this.defaultFormData);
      this.load = true;
 }
  }


  onLoad(data: any) {
    this.cusomsClearanceGroup = this.formBuilder.group({
      clearanceStatus: [null, [Validators.required]],
      rejectionReason: [null],
      comments: [null]
    });

    let keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      console.log(key)
       if (key.indexOf('ics-customs-clearance-status') >= 0) {
        this.inspectionStatusList = data.rdmData[key];
      }
      else if (key.indexOf('ics-customs-clearance-rejectionReasons') >= 0) {
        this.rejectionReasonList = data.rdmData[key];
      }
    });
  }



  
  clearanceStatusChange(value: string) {
    console.log(value)
    const insStatus = this.cusomsClearanceGroup.controls["clearanceStatus"];
    const rejStatus = this.cusomsClearanceGroup.controls["rejectionReason"];
    const appComments = this.cusomsClearanceGroup.controls["comments"];
    if (value.includes("Cleared")) {
      this.showrejectionReason = false;
      insStatus.setValidators(Validators.required);
      rejStatus.clearValidators();
      appComments.clearValidators();
    }
    else if (value.includes("Reject")) {
      this.showrejectionReason = true;
      rejStatus.setValidators([Validators.required]);
      appComments.setValidators([Validators.required]);
      insStatus.clearValidators();
    }
    else {
      this.showrejectionReason = false;
      rejStatus.clearValidators()
      appComments.clearValidators();
    }

  }

  onSubmit() {
    for (const i in this.cusomsClearanceGroup.controls) {
      this.cusomsClearanceGroup.controls[i].markAsDirty();
      this.cusomsClearanceGroup.controls[i].updateValueAndValidity();
    }

    if (this.cusomsClearanceGroup.value.duration !== null) {
      this.formData.variables['clearanceStatus'] = { "value": this.cusomsClearanceGroup.value.clearanceStatus };
    }


    if (this.cusomsClearanceGroup.value.type !== null) {
      this.formData.variables['rejectionReason'] = { "value": this.cusomsClearanceGroup.value.rejectionReason };
    }


    if (this.cusomsClearanceGroup.value.visaNumber !== null) {
      this.formData.variables['comments'] = { "value": this.cusomsClearanceGroup.value.comments };
    }

    if (this.cusomsClearanceGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }
}
